import { render, staticRenderFns } from "./GerarMultipagers.vue?vue&type=template&id=5588459b&scoped=true&"
import script from "./GerarMultipagers.vue?vue&type=script&lang=js&"
export * from "./GerarMultipagers.vue?vue&type=script&lang=js&"
import style0 from "./GerarMultipagers.vue?vue&type=style&index=0&id=5588459b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588459b",
  null
  
)

export default component.exports